interface ControlData {
  prevalence?: number;
  [key: string]: any;
}

interface AltTextData {
  d: string;
  h: string;
}

const updateFunc = (controlData: ControlData): AltTextData => {
  const prevalence =
    controlData["prevalence"] !== undefined ? controlData["prevalence"] : 10;
  const h = 1000 - prevalence;
  const d = prevalence;

  const calculatedData: AltTextData = {
    d: `${d} ${d === 1 ? "person" : "people"}`,
    h: `${h} ${h === 1 ? "person" : "people"}`,
  };
  return calculatedData;
};

export default updateFunc;
